import getConfig from 'next/config';

export const isIMSEnabled = (): boolean => {
  const { publicRuntimeConfig } = getConfig();

  if (publicRuntimeConfig && publicRuntimeConfig.ENABLE_IMS_FEATURES) {
    return publicRuntimeConfig.ENABLE_IMS_FEATURES.toLowerCase() === 'true';
  }
  return false;
};
